import axios from 'axios';

export default {
    methods: {
        async pedidoShow(d, ok, err) {
            try {
                let r = await axios.post('pedido/show', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/pedidoventa.js